<rid-reading-basis-homework-mode
  class="h-dvh"
  instruction="Lees de klankvoeten hardop voor"
  [pace]="pace()"
  [pause]="pause()"
  [words]="[
    {
      word: ['leeuw'],
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
    },
    {
      word: ['tij', 'ger'],
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
    },
    {
      word: ['ze', 'bra'],
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/reading-basis'])"
/>
